import CreditBookApi from '../ApiService/ApiService';
import {UserConfigManager} from '../UserConfigManager';
import {clearLocalStorage, localStorageDictionary} from '../../../localStorage';

/**
 * Clear unauthorized error handler
 */
function clearUnauthorizedErrorHandler() {
  CreditBookApi.setErrorHandler(() => {});
}

/**
 * Safe clear token
 */
function safeClear() {
  try {
    CreditBookApi.clearToken();
  } catch (error) {
    // No-op: If clearing the token fails, we do not want to throw an error
  }

  try {
    UserConfigManager.clear();
  } catch (error) {
    // No-op: If clearing the token fails, we do not want to throw an error
  }

  try {
    // Clear portal profile since it's no longer used
    clearLocalStorage(localStorageDictionary.PORTAL_PROFILE);
  } catch (error) {
    // No-op: If clearing the profile fails, we do not want to throw an error
  }
}

/**
 * Logout user
 */
async function logout() {
  try {
    // Reset the error handler that was set during login
    clearUnauthorizedErrorHandler();

    // Call the logout endpoint
    await CreditBookApi.auth.logout();
  } finally {
    safeClear();

    window.location.href = '/login';
  }
}

export {logout};
